var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeskBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6567 14.4001C16.6567 10.7137 13.8545 7.67004 10.2685 7.28532C10.6245 7.04009 10.8586 6.6301 10.8586 6.16619C10.8586 5.41714 10.2491 4.80762 9.50001 4.80762C8.75095 4.80762 8.14143 5.41714 8.14143 6.16619C8.14143 6.6301 8.37555 7.04009 8.73149 7.28532C5.1455 7.67004 2.34332 10.7137 2.34332 14.4001V14.6475H16.6567V14.4001ZM14.2329 12.7865C13.7952 11.181 12.4552 9.95116 10.8191 9.65354L10.9211 9.09282C12.7718 9.4294 14.2877 10.8204 14.7829 12.6366L14.2329 12.7865Z",
    fill: "#304FC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12 2.40002H9.87999V3.90444H9.12V2.40002Z",
    fill: "#304FC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47334 3.3064L7.13757 2.93628L7.85514 4.22407L7.1909 4.59419L6.47334 3.3064Z",
    fill: "#304FC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80215 5.38831L5.0971 4.68741L6.69649 5.36047L6.40154 6.06137L4.80215 5.38831Z",
    fill: "#304FC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1206 4.27661L11.8704 2.93103L12.5347 3.30115L11.7849 4.64673L11.1206 4.27661Z",
    fill: "#304FC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3813 5.33484L13.9089 4.692L14.2038 5.3929L12.6763 6.03573L12.3813 5.33484Z",
    fill: "#304FC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 15.2175H17.1V17.5999H1.9V15.2175Z",
    fill: "#304FC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskBell);
export default __webpack_public_path__ + "static/media/desk_bell.f4a155fda59717146af803e98bdba281.svg";
export { ForwardRef as ReactComponent };